import React, { useEffect, useState } from "react";
import { languageLabel } from "../../../NewConstants/Language-Constants";
import NextBtn from "../../../Shared/Components/NextBtn/NextBtn";
import "./Introduction.css";
import { getAgents, getConsentFlag, getDefaultLanguage, getOnboardingFlag, getTooltip, getUserToken, getUserType, saveMobileNumber, setDefaultLanguage, stopPlayingAudio, playAudio, handleTooltipOnboarding, setUserToken, setUserType as setUserTypeUtil, setAgents as setAgentsUtil, setUserKb, setUserCadre, setUserApproach, setUserId, setUserProfileData, saveOnboardingFlag, saveConsentFlag, setTooltip, CheckLanguageSupport, isNeGDDeployment, setDeployment } from "../../../Actions/Utils";
import { useNavigate } from "react-router-dom";
import { verifyMobileNumber, verifyOtp } from "../../../Actions/UserActions";
import ToastMessage from "../../../Shared/Components/ToastMessage/ToastMessage";
import { ToastSeverityMap } from "../../../NewConstants/ToastConstants";
import { loginConstant, loginErrorLabels } from "../../../NewConstants/LoginConstant";
import { trackEvent } from "../../../Actions/Utils";
import { getOtpConstant, guideButtons, nextConstant, sendingConstant, title } from "../../../NewConstants/IntroductionConstants";
import { auth } from "../../../firebaseConfig";
import { PhoneAuthProvider, signInWithCredential } from "firebase/auth";
import platform from "platform";
import LoginComponent from "../Auth/LoginComponent/LoginComponent";
import PwaInstallBanner from "../../../Shared/Components/PwaInstallBanner/PwaInstallBanner";

const hide_lang_button = process.env.REACT_APP_HIDE_LANG_BUTTON === 'true'; 
const registrationFlag = process.env.REACT_APP_REGISTRATION === 'true';

const Introduction = ({ selectedLanguage, setSelectedLanguage = () => {}, audioRef, setStepIndex, setStartTour }) => {
  const navigate = useNavigate();
  const [showSpeakerActive, setShowSpeakerActive] = useState(false);
  const [mobileNumber, setMobileNumber] = useState("");
  const [showToastMessage, setShowToastMessage] = useState(false);
  const [toastErrorMessage, setToastErrorMessage] = useState("");
  const [isLoading, setIsLoading] = useState(false);
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [showOtpErrorFlag, setShowOtpErrorFlag] = useState(false);
  const [showMobileErrorFlag, setShowMobileErrorFlag] = useState(false);

  const nextClick = async () => {
    setIsLoading(true);
    if (mobileNumber.length === 10) {
      saveMobileNumber(mobileNumber);
      trackEvent("Login Process", "Proceed", "Entered Mobile and Clicked Next");
      try {
        const res = await verifyMobileNumber("+91"+mobileNumber);
				if (res?.status === 200) {
          if (res["data"]["verified"]) {
            // Do not initialize Recaptcha here. Move to LoginComponent.
            setShowOtp(true);
            setShowSpeakerActive(false);
          } else if (registrationFlag) {
            navigate('/register');
          } else {
            setToastErrorMessage(loginErrorLabels["username"][selectedLanguage])
            setShowToastMessage(true);
          }
        }if (res?.status === 401) {
          setToastErrorMessage(res?.data?.error?.message);
          setShowToastMessage(true);
          setShowMobileErrorFlag(true);
        }
        if(res?.status === 500) {
          setToastErrorMessage(res?.data?.detail)
          setShowToastMessage(true);
        }
      } catch (error) {
        console.error("Verification error:", error);
        setToastErrorMessage("Error verifying mobile number. Please try again.");
        setShowToastMessage(true);
      }
      finally {
        setIsLoading(false);
      }
    } else {
      setToastErrorMessage('Please enter a valid 10-digit mobile number');
      setShowToastMessage(true);
    }
  };

  const handleOtpChange = (e) => {
    setShowOtpErrorFlag(null);
    const value = e.target.value.replace(/\D/g, '');
    if (/^\d{0,6}$/.test(value)) {
      setOtp(value);
    }
  };

  const handleMobileChange = (e) => {
    if (!getDefaultLanguage()){
      setDefaultLanguage(selectedLanguage);
    }
    if (showMobileErrorFlag) {
      setShowMobileErrorFlag(false);
    }
    const value = e.target.value;
    // Check if the entered value is numeric and not exceeding 10 digits
    if (/^\d{0,10}$/.test(value)) {
      setMobileNumber(value);
    }
  };

  useEffect(() => {
    if (showSpeakerActive) {
      const filePath = `/Assets/Sounds/MobileNumberPage/${selectedLanguage}_mobile.mp3`;
      playAudio(filePath, audioRef, () => setShowSpeakerActive(false));
    } else {
      stopPlayingAudio(audioRef);
    }
  }, [showSpeakerActive, selectedLanguage, audioRef]);


  useEffect(() => {
    const handleVisibilityChange = () => {
      stopPlayingAudio(audioRef);
      setShowSpeakerActive(false);
    };

    if(!getUserToken()) {
      const lang = getDefaultLanguage() || selectedLanguage || "en";
      sessionStorage.clear();
      localStorage.clear();
      setDefaultLanguage(lang);
    } else {
      if (getAgents() && getUserType() === "Internal") {
        navigate("/kb-selection");
      } else {
        if (!getOnboardingFlag()) {
          navigate("/guide");
        } else {
          if (!getConsentFlag()) {
            navigate("/consent");
          } else {
            const tooltip = getTooltip();
            handleTooltipOnboarding(tooltip, setStepIndex, setStartTour);
            navigate("/chat");
          }
        }
      }
    }

    document.addEventListener('visibilitychange', handleVisibilityChange);
    return () => {
      document.removeEventListener('visibilitychange', handleVisibilityChange);
    }
  }, [audioRef, navigate, setStepIndex, setStartTour]);

  return (
    // Render LoginComponent screen in-place after OTP is sent, without route change
    showOtp ? (
      <LoginComponent
        selectedLanguage={selectedLanguage}
        audioRef={audioRef}
        setStepIndex={setStepIndex}
        setStartTour={setStartTour}
        onBack={() => setShowOtp(false)}
      />
    ) : (
    <div className="h-screen w-screen flex flex-col">
    <PwaInstallBanner selectedLanguage={selectedLanguage} />
      <div
        className="bg-[var(--primary-dark-2)] flex-1 overflow-y-auto w-screen relative bg-blend-color-burn"
        style={{ backgroundImage: `url("/Assets/Images/wallpaperBg.jpg")` }}
      >
        {/* Language Dropdown/Button Top Left */}
        <button
          className="absolute top-6 left-6 flex items-center justify-between bg-white text-[var(--primary-dark)] font-bold py-2 px-4 rounded-full shadow-md text-lg z-10"
          style={{ minWidth: 120 }}
          onClick={() => {
            stopPlayingAudio(audioRef);
            setShowSpeakerActive(false);
            navigate("/lang");
          }}
        >
          <img src="/Assets/Images/GlobeBlue.svg" alt="globe" className="w-5 h-5 mr-2" onError={(e) => {e.target.style.display='none'}} />
          <span>{languageLabel[selectedLanguage] || ""}</span>
          <svg className="ml-2 w-4 h-4" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" d="M19 9l-7 7-7-7" /></svg>
        </button>
        <div className="relative h-full flex flex-col items-center">
          <div className="w-full p-6 pb-2 flex justify-end ">
              <div 
                className="speakerDiv"
                onClick={() => setShowSpeakerActive((prev) => !prev)}
              >
                {showSpeakerActive ? (
                  <div className="">
                    <img
                      src={"/Assets/Images/blueSpeaker.svg"}
                      alt="active Speaker"
                    />
                  </div>
                ) : (
                  <div className="">
                    <img src={"/Assets/Images/crossSpeakerIcon.svg"} alt="speaker" />
                  </div>
                )}
              </div>
          </div>
          <div className="flex flex-col items-center justify-center">
            <div className="flex flex-col items-center justify-center gap-5 pt-[10%] mb-4">
              <img src="/Assets/Images/Lady_Illustrations/Login.svg" alt="Login" />
                <div className="font-bold text-white text-[1.5rem]">{title[selectedLanguage]["heading"]}</div>
            </div>
          </div>
          <div className="w-[80%] flex flex-col pt-5">
            <div className="flex gap-1.5 items-center mb-4">
              <label className="text-white text-lg">{loginConstant.mobile[selectedLanguage]}</label>
            </div>
            <div className={`flex items-center h-14 rounded-[10px] pt-3 pb-3 pl-4 pr-0 border-[1.5px] ${showMobileErrorFlag ? 'border-[var(--red-1)] bg-[var(--red-3)] focus-within:ring-0 focus-within:border-[var(--red-1)]' : 'border-[var(--dark-neutral-1)] bg-white focus-within:ring-2 focus-within:ring-blue-500 focus-within:border-blue-500'}`}>
              <img
                src="/Assets/Images/phone.svg"
                alt="phone"
                className="w-6 h-6 opacity-60"
              />
              <input
                className="w-full text-xl rounded pt-3 pb-3 pl-4 pr-0 outline-none focus:ring-0 border-none bg-transparent"
                autoFocus
                type="tel"
                placeholder="00000 00000"
                required
                maxLength={10}
                value={mobileNumber}
                onChange={handleMobileChange}
                disabled={showOtp || isLoading}
              />
            </div>
          {showOtp && (
            <div className="flex flex-col gap-2 mt-6">
              <div className="flex gap-1 items-center mb-2">
                <img src={"/Assets/Images/passwordIcon.svg"} alt="password" />
                <label className="text-white">
                  {loginConstant.pass[selectedLanguage]}
                </label>
              </div>
              <input
                className={`text-xl tracking-[0.6rem] inputfield focus:ring-blue-500 focus:border-blue-500 border ${
                  showOtpErrorFlag ? "border-[var(--red-1)]" : "border-[var(--dark-neutral-1)]"
                }`}
                type="tel"
                placeholder="000000"
                required
                minLength={6}
                maxLength={6}
                pattern="[0-9]{6}"
                inputMode="numeric"
                value={otp}
                onChange={handleOtpChange}
              />
              {showOtpErrorFlag && (
                <div className="flex items-center text-[var(--red-1)]">
                  <img src="/Assets/Images/alertCircle.svg" alt="alertcircle" />
                  <span className="pl-2 text-lg">
                    {loginErrorLabels.otp[selectedLanguage]}
                  </span>
                </div>
              )}
            </div>
          )}
          </div>
        <div className="pt-4 cursor-pointer">
          {!showOtp && (
            <NextBtn
              value={isLoading ? sendingConstant[selectedLanguage] : getOtpConstant[selectedLanguage]}
              icon={"/Assets/Images/nextBlueIcon.svg"}
              bgColor={"var(--neutral-white)"}
              color={"var(--primary-dark)"}
              nextClick={nextClick}
              disabled={isLoading || mobileNumber.length !== 10}
              opacity={mobileNumber.length !== 10 ? 0.5 : 1}
            />
          )}
          {showOtp && otp.length === 6 && (
            <NextBtn
              value={isLoading ? loginConstant.verifying[selectedLanguage] : loginConstant.proceedButton[selectedLanguage]}
              icon={"/Assets/Images/nextWhiteIcon.svg"}
              bgColor={"var(--primary-dark)"}
              color={"var(--neutral-white)"}
              // nextClick={verifyOtpFun}
              disabled={isLoading}
            />
          )}
        </div>
          {/* reCAPTCHA handled in LoginComponent */}
        </div>
      </div>
      {
        showToastMessage && <ToastMessage message={toastErrorMessage} severity={ToastSeverityMap.error} direction={"bottom"} close={setShowToastMessage}/>
      }
    </div>
    )
  );
};

export default Introduction;
